// Generated by genversion.
export const version = '0.0.0';
//# sourceMappingURL=version.js.map